import { axiosClient } from "@/shared/api/axios-client";

// Canales y preferencias de notificación del usuario autenticado (backend: PerfilNotificacionesEndpoints).

export interface SuscripcionPush {
  id: string;
  navegador: string | null;
  creadoAt: string;
  ultimoEnvioAt: string | null;
}

export interface MisCanales {
  celular: string | null;
  telegram: {
    disponible: boolean;
    nombreBot: string | null;
    vinculado: boolean;
    nombreEnTelegram: string | null;
    vinculadoAt: string | null;
  };
  push: {
    disponible: boolean;
    clavePublica: string | null;
    suscripciones: SuscripcionPush[];
  };
}

export interface MiNotificacion {
  flujoId: string;
  flujoNombre: string;
  notificacionClave: string;
  notificacionNombre: string;
  canal: string;
  eventos: string[];
  obligatoria: boolean;
  silenciada: boolean;
}

export async function obtenerMisCanales(): Promise<MisCanales> {
  const { data } = await axiosClient.get<MisCanales>("/api/mis-notificaciones/canales");
  return data;
}

/** El celular vive en Identity · se edita con el endpoint del perfil. */
export async function actualizarCelular(celular: string | null): Promise<void> {
  await axiosClient.put("/api/auth/perfil/celular", { celular });
}

export async function generarEnlaceTelegram(): Promise<{ enlace: string; expiraAt: string }> {
  const { data } = await axiosClient.post<{ enlace: string; expiraAt: string }>("/api/mis-notificaciones/telegram/enlace");
  return data;
}

export async function desvincularTelegram(): Promise<void> {
  await axiosClient.delete("/api/mis-notificaciones/telegram");
}

export async function registrarSuscripcionPush(input: {
  endpoint: string;
  p256dh: string;
  auth: string;
  navegador: string | null;
}): Promise<SuscripcionPush> {
  const { data } = await axiosClient.post<SuscripcionPush>("/api/mis-notificaciones/push", input);
  return data;
}

export async function eliminarSuscripcionPush(id: string): Promise<void> {
  await axiosClient.delete(`/api/mis-notificaciones/push/${id}`);
}

export async function desactivarPushEndpoint(endpoint: string): Promise<void> {
  await axiosClient.post("/api/mis-notificaciones/push/desactivar", { endpoint });
}

export async function listarMisPreferencias(): Promise<MiNotificacion[]> {
  const { data } = await axiosClient.get<MiNotificacion[]>("/api/mis-notificaciones/preferencias");
  return data;
}

export async function cambiarPreferencia(input: { flujoId: string; notificacionClave: string; silenciada: boolean }): Promise<void> {
  await axiosClient.put("/api/mis-notificaciones/preferencias", input);
}
